import { components } from "react-select";

export const DropdownIndicator = (props) => {
  return (
    <components.DropdownIndicator {...props}>
      <i className="material-icons-outlined fs-20">keyboard_arrow_down</i>
    </components.DropdownIndicator>
  );
};

export const ClearIndicator = (props) => {
  return (
    <components.ClearIndicator {...props}>
      <i className="material-icons-outlined mr-n3">close</i>
    </components.ClearIndicator>
  );
};

/** Shared react-select tweaks — fixes left-clipped placeholder on mobile (no custom components). */
export const selectFieldStyles = {
  valueContainer: (base) => ({
    ...base,
    padding: "2px 10px",
    overflow: "hidden",
  }),
  input: (base) => ({
    ...base,
    margin: 0,
    paddingTop: 0,
    paddingBottom: 0,
    gridTemplateColumns: "1fr",
    width: "100%",
    maxWidth: "100%",
    minWidth: 0,
    // react-select v5 ghost sizing row — clips placeholder on the left if left enabled
    "&:after": {
      ...(base["&:after"] || {}),
      content: "none",
      display: "none",
    },
  }),
  placeholder: (base) => ({
    ...base,
    marginLeft: 0,
    marginRight: 0,
    width: "100%",
    maxWidth: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    gridArea: "1 / 1 / 2 / 3",
  }),
  singleValue: (base) => ({
    ...base,
    marginLeft: 0,
    marginRight: 0,
    maxWidth: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  }),
};

export const stylesSelect = {
  ...selectFieldStyles,
  control: (provided, state) => ({
    ...provided,
    minHeight: "39px",
    fontSize: "0.875rem",
    color: "#666",
    border: "1px solid #cad1d7",
    border: state.isFocused ? "1px solid #885b24" : "",
    backgroundColor: state.isFocused ? "#e1ebff" : "white",
    boxShadow: state.isFocused ? "#885b24" : "#885b24",
    "&:hover": {
      borderColor: "#885b24",
    },
  }),
  placeholder: (provided) => ({
    ...selectFieldStyles.placeholder(provided),
    color: "#888",
  }),
  dropdownIndicator: (provided, state) => {
    return {
      ...provided,
    };
  },
  indicatorSeparator: (provided, state) => {
    return {
      ...provided,
      display: "none",
    };
  },
  singleValue: (provided, state) => {
    return {
      ...selectFieldStyles.singleValue(provided),
    };
  },
  menu: (provided, state) => ({
    ...provided,
    zIndex: 1000,
  }),
  option: (provided, state) => ({
    ...provided,
    fontSize: "0.875rem",
    color: state.isSelected ? "#fff" : state.isFocused ? "#666" : "#666",
    backgroundColor: state.isSelected
      ? "#885b24"
      : state.isFocused
      ? "#d9d9d9"
      : "#ffffff",
    ":active": {
      backgroundColor: "#885b24",
      color: "#fff",
    },
  }),
};

export const stylesSelectAlternative = {
  ...selectFieldStyles,
  control: (provided, state) => ({
    ...provided,
    minHeight: "43px",
    fontSize: "0.875rem",
    color: "#adb5bd",
    border: "0",
    boxShadow: "0 1px 3px rgb(50 50 93 / 15%), 0 1px 0 rgb(0 0 0 / 2%)",
  }),
  placeholder: (provided) => ({
    ...selectFieldStyles.placeholder(provided),
    color: "#888",
  }),
  dropdownIndicator: (provided, state) => {
    return {
      ...provided,
    };
  },
  indicatorSeparator: (provided, state) => {
    return {
      ...provided,
      display: "none",
    };
  },
  singleValue: (provided, state) => {
    return {
      ...selectFieldStyles.singleValue(provided),
    };
  },
  menu: (provided, state) => ({
    ...provided,
    zIndex: 1000,
  }),
  option: (provided, state) => ({
    ...provided,
    color: state.isFocused || state.isSelected ? "#ffffff" : "#32325d",
    backgroundColor:
      state.isFocused || state.isSelected ? "#885b24" : "#ffffff",
  }),
};
